import { List } from "immutable";

export default {
  SET_PAGING(state, data) {
    state.pageable = data;
  },

  SET_FEATURES(state, features) {
    state.features = List(features);
  },

  /** プライベートプロットのstateを更新 */
  ADD_PRIVATE_PLOT(state, data) {
    // onSnapshotが0件のときはプライベートプロットを空にする
    if (!data) {
      state.privatePlots.splice(0, state.privatePlots.length);
      return;
    }

    const index = state.privatePlots.findIndex((plot) => {
      return plot.hash === data.hash;
    });

    if (index === -1) {
      state.privatePlots.push(data);
    } else {
      state.privatePlots.splice(index, 1, data);
    }
  },

  /** プライベートプロットのstateを置き換える */
  SET_PRIVATE_PLOTS(state, payload) {
    if (!Array.isArray(payload)) return;
    state.privatePlots = payload;
  },

  /** プライベートプロットをstateから除外 */
  REMOVE_PRIVATE_PLOTS(state, data) {
    if (!data) return;
    const index = state.privatePlots.findIndex((a) => a.hash === data.hash);
    if (index !== -1) {
      state.privatePlots.splice(index, 1);
    }
  },
  ADD_POINT(state, point) {
    state.points = state.points.push(point);
  },
  SET_POINT(state, points) {
    state.points = List(points);
  },
  CLEAR_POINT(state) {
    state.points = List();
    state.editMode = 0;
  },
  SET_EDIT_MODE(state, mode) {
    state.editMode = mode;
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
